export default __webpack_public_path__ + "static/media/parallax.69537449.jpeg";